// @copyright  2025 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: 'referrals',
        component: () =>
            import('@/pages/[organisation]/settings/referrals/referral-list.vue'),
        name: 'settings.referrals.dashboard',
        meta: {
            loginRequired: true,
            permission: 'access.saas.subscription-invoice.view-subscription-invoices',
        },
    },

    {
        path: 'referrals/list',
        component: () =>
            import(/* webpackChunkName: "settings.referrals" */ '@/pages/[organisation]/settings/referrals/referral-list.vue'),
        name: 'settings.referrals.list',
        meta: {
            loginRequired: true,
            permission: 'access.saas.subscription-invoice.view-subscription-invoices',
        },
    },

    {
        path: 'referrals/:id',
        component: () =>
            import(/* webpackChunkName: "settings.referrals" */ '@/pages/[organisation]/settings/referrals/referral-details.vue'),
        name: 'settings.referrals.details',
        meta: {
            loginRequired: true,
            permission: 'access.saas.subscription-invoice.view-subscription-invoices',
        },
    },

    {
        path: 'referrals/commissions',
        component: () =>
            import(/* webpackChunkName: "settings.referrals" */ '@/pages/[organisation]/settings/referrals/commission-list.vue'),
        name: 'settings.referrals.commissions',
        meta: {
            loginRequired: true,
            permission: 'access.saas.subscription-invoice.view-subscription-invoices',
        },
    },

    {
        path: 'referrals/payouts',
        component: () =>
            import(/* webpackChunkName: "settings.referrals" */ '@/pages/[organisation]/settings/referrals/payout-list.vue'),
        name: 'settings.referrals.payouts',
        meta: {
            loginRequired: true,
            permission: 'access.saas.subscription-invoice.view-subscription-invoices',
        },
    },
];
